const companyName = process.env.REACT_APP_COMPANY_NAME as string;
const serverURL = process.env.REACT_APP_SERVER_API_DOMAIN as string;
const appURL = process.env.REACT_APP_CLIENT_DOMAIN as string;
const appURI = process.env.REACT_APP_URI as string;
const appServerDomain = process.env.REACT_APP_SERVER_DOMAIN as string;
const appHomePage = process.env.REACT_APP_PUBLIC_URL as string;

/*console.log(
  'process.env.REACT_APP_SIPOUserHomeUrl:   ' +
    process.env.REACT_APP_SIPOUserHomeUrl,
);
console.log('companyName:: ' + companyName);
console.log('serverURL:: ' + serverURL);
console.log('appURL:: ' + appURL);
console.log('appURI:: ' + appURI);
console.log('SERVER_API_DOMAIN:: ' + process.env.REACT_APP_SERVER_API_DOMAIN);
console.log('REACT_APP_SERVER_DOMAIN:: ' + process.env.REACT_APP_SERVER_DOMAIN);
console.log('CLIENT_DOMAIN:: ' + process.env.REACT_APP_CLIENT_DOMAIN);
console.log('REACT_APP_API_URI:: ' + process.env.REACT_APP_API_URI);
*/
export const config = {
  companyName: companyName,
  serverDomain: appServerDomain,
  appHomePage: appHomePage,
  serverURL: serverURL,
  appURL: appURL,
  appURI: appURI,
  redirectUrlForUnAuthorizedUsers:
    process.env.REACT_APP_REDIRECT_URL_FOR_UNAUTHORIZED_USERS,

  jwtTokenStoreName: 'Bearer',
  localUserDTO: 'userDTO',
  fullAge: 18,

  httpStatusCodes: {
    OK: 200,
    CREATED: 201,
    ACCEPTED: 202,
    NO_CONTENT: 204,

    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    ALREADY_EXISTS: 409,

    INTERNAL_SERVER: 500,
    NOT_IMPLEMENTED: 501,
    SERVICE_UNAVAILABLE: 503,
  },

  passwordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
  emailRegExp: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  NITRegExp: /(^[0-9]+-{1}[0-9]{1})/,
  urlRegularExpression: RegExp(
    '((http|https)://)(www.)?' +
      '[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]' +
      '{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)',
  ),
  OnlyNumbersRegExp: /^\d+$/,

  react_routes: {
    prefix: '',
    modules: {
      config: {
        prefix: '/config',
        services: {
          home: '/home',
          friendly: '/friendly',
          editParam: '/id/:id',
          addParam: '/addParam',
          updateParam: '/updateParam',
          deleteParam: '/deleteParam',
          updateOfac: '/updateOfac',
        },
      },
      audit: {
        prefix: '/admin/audit',
        services: {
          home: '/',
          getAuditRecord: '/getAuditRecord',
        },
      },
      notification: {
        prefix: '/admin/notification',
        services: {
          home: '/',
          editNotification: '/id/:id',
        },
      },
      user: {
        prefix: '/user',
        services: {
          add: '/add',
          signin: '/signin',
          emailVerify: '/emailVerify',
          changePassword: '/changePassword',
          passwordResetRequest: '/passwordResetRequest',
          passwordReset: '/passwordReset',
          currentUser: '/currentUser',
          profileUpdate: '/profileUpdate',
        },
      },
      membership: {
        prefix: '/membership',
        services: {
          request: '/request',
          emailVerify: '/emailVerify',
          paymentSend: '/paymentSend',
          status: '/status',
          processValidation: '/processValidation',
          list: '/list',
          search: '/search',
          resendEmailVerification: '/resendEmailVerification',
        },
      },

      userAdmin: {
        prefix: '/admin/user',
        services: {
          home: '/',
          add: '/add',
          edit: '/:id',
          delete: '/delete/:id',
          emailVerify: '/emailVerify',
        },
      },
      memberShipAdmin: {
        prefix: '/admin/membership',
        services: {
          home: '/',
          edit: '/:id',
          delete: '/delete/:id',
        },
      },
      credit: {
        prefix: '/credit',
        services: {
          home: '/',
          request: '/request',
        },
      },
      creditAdmin: {
        prefix: '/admin/credit',
        services: {
          home: '/',
          edit: '/:id',
          delete: '/delete/:id',
        },
      },
      commercial: {
        prefix: '/commercial',
        services: {
          addCandidate: '/candidate/add',
          emailVerify: '/candidate/emailVerify',
          poll: '/candidate/poll',
        },
      },
    },
  },

  /**
   * API configs
   */
  api_routes: {
    prefix: process.env.REACT_APP_API_URI,
    modules: {
      config: {
        prefix: '/config',
        services: {
          home: '/home',
          getParam: '/getParam',
          addParam: '/addParam',
          updateParam: '/updateParam',
          updateParamValue: '/updateParamValue',
          deleteParam: '/deleteParam',
          dashboard: '/dashboard',
          configClientParams: '/configClientParams',
          updateOfac: '/updateOfac',
          frontendInit: '/feInit',
        },
      },
      audit: {
        prefix: '/audit',
        services: {
          home: '/home',
          getNotification: '/getAuditRecord',
        },
      },
      user: {
        prefix: '/user',
        services: {
          signin: '/signin',
          signout: '/signout',
          changePassword: '/changePassword',
          passwordResetRequest: '/passwordResetRequest',
          passwordReset: '/passwordReset',
          currentUser: '/currentUser',
          profileUpdate: '/profileUpdate',
          emailVerify: '/emailVerify',
        },
      },
      membership: {
        prefix: '/membership',
        services: {
          request: '/request',
          emailVerify: '/emailVerify',
          paymentSend: '/paymentSend',
          processValidation: '/processValidation',
          checkStatus: '/checkStatus',
          resendEmailVerification: '/resendEmailVerification',
          list: '/list',
          search: '/search',
        },
      },
      userAdmin: {
        prefix: '/user/admin',
        services: {
          home: '/users',
          add: '/add',
          edit: '/edit',
          update: '/update',
          delete: '/delete',
        },
      },
      memberShipAdmin: {
        prefix: '/membership/admin',
        services: {
          home: '/',
          edit: '/edit',
          update: '/update',
          delete: '/delete',
          export: '/export',
          approve: '/approve',
          exportToAccountSystem: '/exportToAccountSystem',
        },
      },
      creditAdmin: {
        prefix: '/credit/admin',
        services: {
          home: '/',
          edit: '/edit',
          update: '/update',
          delete: '/delete',
          export: '/export',
          exportToAccountSystem: '/exportToAccountSystem',
        },
      },
      credit: {
        prefix: '/credit',
        services: {
          request: '/request',
        },
      },
      commercial: {
        prefix: '/commercial',
        services: {
          addCandidate: '/candidate/add',
          emailVerify: '/candidate/emailVerify',
          poll: '/candidate/poll',
        },
      },
    },
  },

  cooperative: {
    monthlyMinimumSalary: 1000000,
    association: {
      companyAssociationTuition: 200000,
      personalAssociationTuition: 60000,
      valueOfMonthlyContributionRangeForPersons: [50000, 3500000],
      valueOfMonthlyContributionRangeForCompanies: [50000, 3500000],
      suggestedMonthlyContributionsForPersons: [
        { _id: '', name: '', value: 0 },
      ],
      suggestedMonthlyContributionsForCompanies: [
        { _id: '', name: '', value: 0 },
      ],
      beneficiaryType: [{ _id: '', code: '', name: '' }],
      inscriptionHeaderTitle: 'Formulario de Inscripción',
      inscriptionHeaderText: `Para asociarse a la cooperativa, por favor diligencie el siguiente 
        formato de inscripción y realice el pago correspondiente al estudio de ingreso,
        y en breve recibirá la respuesta`,
    },
  },

  digitalLibrary: {
    maxFileSize: 100000000,
    documents: {
      new: {
        headerTitle: 'Agregar Documento',
        headerText:
          'Aquí puede vincular documentos electrónicos en diversos formatos y además puede asociarle archivos anexos y adjuntos',
      },
      personDocuments: {
        headerTitle: 'Documentos del Usuario',
        headerText: 'Lista de los documentos registrados',
      },
    },
    areas: [
      { _id: '', name: 'Área de Procesos', code: 'LP' },
      { _id: '', name: 'Centro de Comnciliación', code: 'CC' },
    ],
    stages: {
      legalProcess: [
        { _id: '', name: 'Consulta', code: 'Q' },
        { _id: '', name: 'Entrevista', code: 'CC' },
      ],
      conciliationCenter: [
        { _id: '', name: 'Solicitud', code: 'SC' },
        { _id: '', name: 'Audiencia', code: 'AU' },
      ],
    },
  },

  membership: {
    UNVALIDATED_STATE: 'UNVALIDATED',
    VALIDATED_STATE: 'VALIDATED',
    IS_REPORTED: 'IR',
    NOT_REPORTED: 'NR',
  },
  security: {
    roleNames: {
      undefinedRoleName: 'undefined',
      superAdminRoleName: 'SECOFER',
      superAdminFSJPRoleName: 'FSJP_SECOFER',
      standarUserRoleName: 'user',
    },
    redirectFromEmailVerifiedToSignIn: true,
  },
  credit: {
    freeUseEnabled: true,
    freeUseCreditAmmountRange: [50000, 3500000],
    rangeFreeUseCreditInstallments: [3, 36],

    multiActivityEnabled: true,
    multiActivityCreditAmmountRange: [50000, 3500000],
    multiActivityCreditInstallments: [3, 36],

    SOATEnabled: true,
    SOATCreditAmmountRange: [300000, 1500000],
    rangeSOATCreditInstallments: [3, 36],
  },
  general: {
    ISOCountryCode: 'co',
    ISOLanguageCode: 'es-CO',
    TimeZone: 'America/Bogota',
    TimeZoneGMT: '-05',
    currencyISOCountryCode: 'COP',
  },
  UI: {
    drawerWidth: 240,
    tinyAPIKey: '',
    keepResidentInCurrentPageOnSuccess: true,
  },
};

export const getInnerVariable = (variableName: string, mainObject: Object) => {
  const hierarchy = variableName.split('.');
  let parent = mainObject;
  let i = 0;
  let child: string[];
  for (i = 1; i < hierarchy.length; i++) {
    const _key = hierarchy[i];
    if ((child = Object.keys(parent).filter(key => key === _key))) {
      parent = parent[child[0]];
    } else {
      return null;
    }
  }
  return parent;
};

export const isVariableTrue = (variableName: string, mainObject: Object) => {
  let value: Object | null = getInnerVariable(variableName, mainObject);
  if (typeof value === 'string') {
    value = value.toLowerCase();
    return value === 'true' || value === 'yes';
  }
  if (typeof value === 'boolean') {
    return value;
  }
  return false;
};

export const existsVariable = (variableName: string, mainObject: Object) => {
  let value: Object | null = getInnerVariable(variableName, mainObject);
  return value !== undefined && value !== null;
};

export const isNumberVariable = (variableName: string, mainObject: Object) => {
  let value: Object | null = getInnerVariable(variableName, mainObject);
  if (typeof value === 'number') {
    return Number.isFinite(value);
  }
  if (typeof value === 'string') {
    return !isNaN(Number.parseFloat(value));
  }
};

export const setInnerVariable = (
  variableName: string,
  newValue,
  mainObject: Object,
) => {
  const hierarchy = variableName.split('.');
  let parent = mainObject;
  let i = 0;
  let child: string[];
  for (i = 1; i < hierarchy.length; i++) {
    const _key = hierarchy[i];
    if ((child = Object.keys(parent).filter(key => key === _key))) {
      if (i === hierarchy.length - 1) {
        parent[child[0]] = newValue;
      } else {
        parent = parent[child[0]];
      }
    }
  }
};

export const getAllVariablesFlat = (mainObject: Object): string[] => {
  let parent = mainObject;
  let childObjectsFlat: string[] = [];
  Object.keys(parent).forEach(child => {
    if (typeof parent[child] === 'object') {
      const childs = Object.keys(parent[child]);
      if (childs && childs.length > 0) {
        const childNames = getAllVariablesFlat(parent[child]);
        childObjectsFlat = childObjectsFlat.concat(
          childNames.map(item => {
            return child + '.' + item;
          }),
        );
      }
    } else {
      childObjectsFlat.push(
        child + '/' + typeof parent[child] + ' = ' + parent[child],
      );
    }
  });
  return childObjectsFlat;
};
